import React from 'react';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { TextBlockStyles } from '../../constants/textStyleConstants';
import { useEditorContext } from '../../logic/EditorContext';
var ParagraphControls = function () {
    var _a = useEditorContext(), contentHelper = _a[1];
    var blockType = contentHelper.blockTypeAtSelection;
    var blockTypeForSelector = Object.values(TextBlockStyles).includes(blockType) ? blockType : 'unstyled';
    var handleChange = function (event) {
        event.preventDefault();
        contentHelper.toggleBlockType(event.target.value);
    };
    var handleStopPropagation = function (event) {
        event.preventDefault();
    };
    return (React.createElement(Select, { id: "demo-simple-select", className: "RichEditor-ParagraphControls", disableUnderline: true, value: blockTypeForSelector, onChange: handleChange },
        React.createElement(MenuItem, { onMouseDown: handleStopPropagation, className: 'RichEditor-ParagraphControls--paragraph', value: TextBlockStyles.paragraph }, "Paragraph"),
        React.createElement(MenuItem, { onMouseDown: handleStopPropagation, className: 'RichEditor-ParagraphControls--header1', value: TextBlockStyles.h1 }, "Header 1"),
        React.createElement(MenuItem, { onMouseDown: handleStopPropagation, className: 'RichEditor-ParagraphControls--header2', value: TextBlockStyles.h2 }, "Header 2"),
        React.createElement(MenuItem, { onMouseDown: handleStopPropagation, className: 'RichEditor-ParagraphControls--header3', value: TextBlockStyles.h3 }, "Header 3")));
};
export default ParagraphControls;
//# sourceMappingURL=ParagraphControls.js.map